var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { ProctorExamStatusEnum, ProctorReportStatusEnum, ProctorReportStatusMLModelEnum, VideoModeEnum, } from "../../submodules/Assessment-Platform-1.0-Dtos-FE/src/dtos/proctor/proctorResult.dto";
import { useApplicationContext } from "../../context/application-context";
import { useRecoilValue } from "recoil";
import { instructionDataRecoil } from "../../atoms/global-state";
import { isMobileWidth } from ".";
import proctoringService from "../../api-client/services/proc-service";
import { messages } from "../../submodules/Inventory-Module-Types/src/utils/messages";
const ScreenRecorderPage = () => {
    const { tenantSettings } = useApplicationContext();
    const instructionData = useRecoilValue(instructionDataRecoil);
    const mediaRecorderRef = useRef(null);
    const displayStreamRef = useRef(null);
    const micStreamRef = useRef(null);
    const audioContextRef = useRef(null);
    const isFirstUploadRef = useRef("true");
    const chunkIndexRef = useRef(0);
    const startTimeRef = useRef(null);
    const [isRecording, setIsRecording] = useState(false);
    const [error, setError] = useState(null);
    const sessionStorageData = sessionStorage.getItem(messages.SESSION_INTERVIEW_META_DATA);
    const interviewMetaData = sessionStorageData
        ? JSON.parse(sessionStorageData)
        : null;
    const userId = interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId;
    const interviewId = interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId;
    const attemptNumber = (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.attemptNum) || 1;
    const duration = (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.duration) || 40;
    const stopTracks = () => {
        if (displayStreamRef.current) {
            const tracks = displayStreamRef.current.getTracks();
            tracks.forEach((track) => {
                try {
                    track.stop();
                }
                catch (err) {
                    console.error("Failed to stop display track", err);
                }
            });
            displayStreamRef.current = null;
        }
        if (micStreamRef.current) {
            const tracks = micStreamRef.current.getTracks();
            tracks.forEach((track) => {
                try {
                    track.stop();
                }
                catch (err) {
                    console.error("Failed to stop mic track", err);
                }
            });
            micStreamRef.current = null;
        }
        if (audioContextRef.current) {
            try {
                audioContextRef.current.close();
            }
            catch (err) {
                console.error("Failed to close audio context", err);
            }
            audioContextRef.current = null;
        }
    };
    const uploadChunk = (file) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!tenantSettings) {
            return;
        }
        const formData = new FormData();
        formData.append("upload", file, `${chunkIndexRef.current}.mp4`);
        const directoryName = userId && interviewId && attemptNumber
            ? `${userId}_examId_${attemptNumber}_${interviewId}`
            : "testing";
        const startTime = startTimeRef.current !== null ? startTimeRef.current : new Date();
        const params = {
            directoryName,
            userId: userId ? userId : "testing",
            examId: interviewId ? interviewId.toString() : "44",
            isFirstUpload: isFirstUploadRef.current,
            attemptNumber: attemptNumber ? attemptNumber : 1,
            examDuration: duration ? duration : 40,
            status: ProctorReportStatusEnum.PENDING,
            startTime,
            examStatus: ProctorExamStatusEnum.NOT_YET_UPDATED,
            mlModelFlag: true,
            mlModelStatus: ProctorReportStatusMLModelEnum.FINISHED,
            tenantId: tenantSettings.id,
            videoMode: VideoModeEnum.MEETING_CAPTURE,
            guiltyFlagData: [],
            videoAnswerTimeStamp: JSON.stringify([]),
            avgFaceMatch: "",
            streamSettings: JSON.stringify({
                interval: ((_b = (_a = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _a === void 0 ? void 0 : _a.streamSettings) === null || _b === void 0 ? void 0 : _b.interval) || 5,
                isRequired: (_e = (_d = (_c = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _c === void 0 ? void 0 : _c.streamSettings) === null || _d === void 0 ? void 0 : _d.isRequired) !== null && _e !== void 0 ? _e : false,
                checkForPlagiarism: (_h = (_g = (_f = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _f === void 0 ? void 0 : _f.streamSettings) === null || _g === void 0 ? void 0 : _g.checkForPlagiarism) !== null && _h !== void 0 ? _h : false,
                checkForVoicePrintAnalysis: (_l = (_k = (_j = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _j === void 0 ? void 0 : _j.streamSettings) === null || _k === void 0 ? void 0 : _k.checkForVoicePrintAnalysis) !== null && _l !== void 0 ? _l : false,
            }),
            isMobileDevice: isMobileWidth,
            isLiveProctoring: (_o = (_m = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _m === void 0 ? void 0 : _m.isLiveProctoring) !== null && _o !== void 0 ? _o : false,
        };
        try {
            yield proctoringService.sendDataToMultiMediaService(formData, params);
            isFirstUploadRef.current = "false";
            chunkIndexRef.current = chunkIndexRef.current + 1;
        }
        catch (err) {
            console.error("Screen recording upload failed", err);
        }
    });
    const handleStart = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isRecording) {
            return;
        }
        setError(null);
        try {
            // Capture display/tab with audio (meeting/system audio)
            const displayStream = yield navigator.mediaDevices.getDisplayMedia({
                video: true,
                audio: true,
            });
            const displayAudioTracks = displayStream.getAudioTracks();
            if (!displayAudioTracks || displayAudioTracks.length === 0) {
                setError("No audio detected. Please select a tab/window with audio and enable 'Share tab audio', then try again.");
                displayStream.getTracks().forEach((track) => {
                    try {
                        track.stop();
                    }
                    catch (err) {
                        console.error("Failed to stop track after missing audio", err);
                    }
                });
                return;
            }
            // Capture candidate mic audio with better quality constraints
            const micStream = yield navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: false,
                    noiseSuppression: false,
                    autoGainControl: false,
                    sampleRate: 48000,
                },
            });
            // Create AudioContext to mix display audio + mic audio
            const audioContext = new AudioContext({
                sampleRate: 48000,
            });
            audioContextRef.current = audioContext;
            // Ensure AudioContext is running (resume if suspended)
            if (audioContext.state === "suspended") {
                yield audioContext.resume();
            }
            // Create source nodes for both audio streams
            const displayAudioSource = audioContext.createMediaStreamSource(displayStream);
            const micAudioSource = audioContext.createMediaStreamSource(micStream);
            // Create gain nodes to control audio levels and prevent clipping
            const displayGain = audioContext.createGain();
            const micGain = audioContext.createGain();
            // Set gain values (0.8 = 80% volume to prevent clipping)
            displayGain.gain.value = 0.8;
            micGain.gain.value = 0.8;
            // Create destination node (this will output the mixed audio)
            const audioDestination = audioContext.createMediaStreamDestination();
            // Connect sources -> gain nodes -> destination (mixing them)
            displayAudioSource.connect(displayGain);
            displayGain.connect(audioDestination);
            micAudioSource.connect(micGain);
            micGain.connect(audioDestination);
            // Monitor track states to ensure they stay enabled
            const micTracks = micStream.getAudioTracks();
            micTracks.forEach((track) => {
                track.onended = () => {
                    console.warn("Mic track ended unexpectedly");
                };
                track.onmute = () => {
                    console.warn("Mic track muted");
                };
                if (track.muted) {
                    console.warn("Mic track is muted, attempting to unmute");
                    track.enabled = true;
                }
            });
            // Combine display video + mixed audio into one stream
            const combinedStream = new MediaStream();
            // Add video tracks from display
            displayStream
                .getVideoTracks()
                .forEach((track) => combinedStream.addTrack(track));
            // Add the mixed audio track from the destination
            audioDestination.stream
                .getAudioTracks()
                .forEach((track) => combinedStream.addTrack(track));
            startTimeRef.current = new Date();
            displayStreamRef.current = displayStream;
            micStreamRef.current = micStream;
            const mediaRecorder = new MediaRecorder(combinedStream);
            mediaRecorder.ondataavailable = (event) => __awaiter(void 0, void 0, void 0, function* () {
                if (event.data && event.data.size > 0) {
                    yield uploadChunk(event.data);
                }
            });
            mediaRecorder.onstop = () => {
                var _a;
                // Clear monitoring interval
                const interval = (_a = mediaRecorderRef.current) === null || _a === void 0 ? void 0 : _a.__trackMonitorInterval;
                if (interval) {
                    clearInterval(interval);
                }
                stopTracks();
            };
            mediaRecorderRef.current = mediaRecorder;
            // Monitor AudioContext state and keep it running
            audioContext.onstatechange = () => {
                if (audioContext.state === "suspended") {
                    console.warn("AudioContext suspended, resuming...");
                    audioContext.resume();
                }
            };
            // Periodically check and ensure mic tracks are enabled
            const trackMonitorInterval = setInterval(() => {
                var _a;
                if (!mediaRecorderRef.current ||
                    mediaRecorderRef.current.state === "inactive") {
                    clearInterval(trackMonitorInterval);
                    return;
                }
                const micTracks = ((_a = micStreamRef.current) === null || _a === void 0 ? void 0 : _a.getAudioTracks()) || [];
                micTracks.forEach((track) => {
                    if (!track.enabled || track.muted) {
                        console.warn("Mic track disabled/muted, re-enabling");
                        track.enabled = true;
                    }
                });
                if (audioContext.state === "suspended") {
                    console.warn("AudioContext suspended, resuming...");
                    audioContext.resume();
                }
            }, 2000); // Check every 2 seconds
            // Store interval ID for cleanup
            mediaRecorderRef.current.__trackMonitorInterval =
                trackMonitorInterval;
            mediaRecorder.start();
            setIsRecording(true);
        }
        catch (err) {
            console.error("Failed to start screen recording", err);
            setError("Failed to start screen recording. Please try again.");
            stopTracks();
            setIsRecording(false);
        }
    });
    const handleStop = () => {
        var _a;
        try {
            if (mediaRecorderRef.current) {
                // Clear monitoring interval
                const interval = (_a = mediaRecorderRef.current) === null || _a === void 0 ? void 0 : _a.__trackMonitorInterval;
                if (interval) {
                    clearInterval(interval);
                }
                mediaRecorderRef.current.stop();
                mediaRecorderRef.current = null;
            }
        }
        catch (err) {
            console.error("Failed to stop screen recorder", err);
        }
        finally {
            stopTracks();
            setIsRecording(false);
            // if (window.opener && !window.opener.closed) {
            //   window.opener.focus();
            // }
            // window.close();
        }
    };
    useEffect(() => {
        return () => {
            try {
                if (mediaRecorderRef.current) {
                    mediaRecorderRef.current.stop();
                    mediaRecorderRef.current = null;
                }
            }
            catch (err) {
                console.error("Failed to stop recorder on unmount", err);
            }
            stopTracks();
        };
    }, []);
    return (_jsxs("div", Object.assign({ style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            padding: 16,
            textAlign: "center",
        } }, { children: [_jsx("h2", { children: "Screen + Audio Recording Setup" }), _jsx("p", Object.assign({ style: {
                    maxWidth: 480,
                    marginTop: 8,
                    marginBottom: 16,
                } }, { children: "When you click the button below, your browser will ask you to select a tab/window or screen. Please choose the interview tab/window and make sure audio sharing is enabled." })), error && (_jsx("div", Object.assign({ style: {
                    color: "#cf1322",
                    marginBottom: 12,
                } }, { children: error }))), !isRecording ? (_jsx("button", Object.assign({ type: "button", onClick: handleStart, style: {
                    padding: "8px 16px",
                    cursor: "pointer",
                    borderRadius: 4,
                    border: "1px solid #fa8c16",
                    backgroundColor: "#ffa940",
                    color: "#ffffff",
                    fontSize: 14,
                } }, { children: "Start screen+audio capture" }))) : (_jsx("button", Object.assign({ type: "button", onClick: handleStop, style: {
                    padding: "8px 16px",
                    cursor: "pointer",
                    borderRadius: 4,
                    border: "1px solid #cf1322",
                    backgroundColor: "#ff4d4f",
                    color: "#ffffff",
                    fontSize: 14,
                } }, { children: "Stop recording and return to interview" }))), isRecording && (_jsx("p", Object.assign({ style: { marginTop: 16, maxWidth: 480 } }, { children: "Recording is running. You can now switch back to your interview tab. Do not close this tab until you are done recording." })))] })));
};
export default ScreenRecorderPage;
